import React, { useRef } from "react";
import { Camera, Loader, X } from "lucide-react";
import Modal from "../../../components/common/Modal";

const GuideFormModal = ({
  open,
  onClose,
  newGuide,
  setNewGuide,
  handleSubmit,
  loadingSubmit,
  handleImageChange,
  handleRemoveImage,
}) => {
  const fileInputRef = useRef(null);

  const headerContent = (
    <div>
      <h2 className="tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-2xl tw-font-bold tw-text-transparent">
        Nominate a Guide
      </h2>
      <p className="tw-mt-2 tw-text-gray-500">
        Tell us about an amazing guide who deserves to experience Sofest!
      </p>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} headerContent={headerContent}>
      <form onSubmit={handleSubmit} className="tw-space-y-8">
        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            Guide's Name *
          </label>
          <input
            type="text"
            required
            placeholder="e.g. John Doe"
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
            value={newGuide.guide_name}
            onChange={(e) =>
              setNewGuide({
                ...newGuide,
                guide_name: e.target.value,
              })
            }
          />
        </div>

        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            Which trip did you meet this guide on? *
          </label>
          <input
            type="text"
            required
            placeholder="e.g. Bali Adventure 2024"
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
            value={newGuide.trip_experience}
            onChange={(e) =>
              setNewGuide({
                ...newGuide,
                trip_experience: e.target.value,
              })
            }
          />
        </div>

        <div>
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            Why should this guide come to Sofest? *
          </label>
          <textarea
            rows={4}
            required
            placeholder="Tell us what made this guide special! How did they impact your trip? What makes them deserve this experience?"
            className="tw-mt-2 tw-block tw-w-full tw-rounded-xl tw-border-0 tw-bg-gray-50 tw-px-4 tw-py-3.5 tw-text-gray-900 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-gray-200 tw-transition-all placeholder:tw-text-gray-400 focus:tw-ring-2 focus:tw-ring-[deepskyblue]"
            value={newGuide.description}
            onChange={(e) =>
              setNewGuide({
                ...newGuide,
                description: e.target.value,
              })
            }
          />
        </div>

        <div className="tw-space-y-4">
          <label className="tw-block tw-bg-gradient-to-r tw-from-gray-800 tw-to-gray-600 tw-bg-clip-text tw-text-base tw-font-medium tw-text-transparent">
            Upload Photos *
          </label>
          <p className="tw-text-sm tw-text-gray-500">
            Add photos of your guide and/or your best memories from the trip
          </p>
          <input
            type="file"
            accept="image/*"
            multiple
            ref={fileInputRef}
            onChange={handleImageChange}
            className="tw-hidden"
          />
          <div className="tw-grid tw-grid-cols-2 tw-gap-4">
            {newGuide.imagePreviews.map((preview, index) => (
              <div key={index} className="tw-relative">
                <img
                  src={preview}
                  alt={`Preview ${index + 1}`}
                  className="tw-h-48 tw-w-full tw-rounded-xl tw-object-cover"
                />
                <button
                  type="button"
                  onClick={() => handleRemoveImage(index)}
                  className="tw-absolute tw-right-2 tw-top-2 tw-rounded-full tw-bg-white tw-p-1 hover:tw-bg-gray-100"
                >
                  <X className="tw-h-4 tw-w-4 tw-text-gray-500" />
                </button>
              </div>
            ))}
            <div
              onClick={() => fileInputRef.current?.click()}
              className="tw-relative tw-flex tw-h-48 tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-xl tw-border-2 tw-border-dashed tw-border-gray-300 tw-bg-gray-50 tw-transition-colors hover:tw-bg-gray-100"
            >
              <div className="tw-text-center">
                <Camera className="tw-mx-auto tw-mb-2 tw-h-8 tw-w-8 tw-text-gray-400" />
                <p className="tw-text-sm tw-text-gray-500">Click to upload</p>
              </div>
            </div>
          </div>
        </div>

        <div className="tw-flex tw-justify-end tw-space-x-4 tw-pt-4">
          <button
            type="submit"
            disabled={loadingSubmit}
            className="tw-flex tw-items-center tw-space-x-2 tw-rounded-xl tw-bg-gradient-to-r tw-from-[#ff6b6b] tw-to-pink-500 tw-px-8 tw-py-3.5 tw-text-base tw-font-medium tw-text-white tw-shadow-lg tw-transition-all hover:tw-shadow-xl disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
          >
            {loadingSubmit ? (
              <>
                <Loader className="tw-h-5 tw-w-5 tw-animate-spin" />
                <span>Submitting...</span>
              </>
            ) : (
              <span>Nominate Guide</span>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default GuideFormModal;
